// extracted by mini-css-extract-plugin
export var wrapper = "recent-module--wrapper--vxl2b";
export var colorWrapper = "recent-module--colorWrapper--f-0Vp recent-module--wrapper--vxl2b global-full-width";
export var list = "recent-module--list--ezC1k";
export var slider = "recent-module--slider--H+Pm8";
export var post = "recent-module--post--tcBtW";
export var postImage = "recent-module--postImage--yoWPJ";
export var postTitle = "recent-module--postTitle--TpyAm";
export var postTitleMore = "recent-module--postTitleMore---7jQU";
export var postDate = "recent-module--postDate--JcyZY";